{
  "es": {
      "Yes": "Sí",
      "No": "No",
      "Cancel": "Cancelar",
      "Close": "Cerrar",
      "Clear": "Limpiar",
      "Done": "Hecho",
      "Loading": "Cargando...",
      "Select": "Seleccionar...",
      "Search": "Buscar",
      "Back": "Volver",
      "OK": "Aceptar",

      "dxCollectionWidget-noDataText": "Sin datos para mostrar",

      "dxDropDownEditor-selectLabel": "Seleccionar",

      "validation-required": "Obligatorio",
      "validation-required-formatted": "{0} es obligatorio",
      "validation-numeric": "Valor debe ser un número",
      "validation-numeric-formatted": "{0} debe ser un número",
      "validation-range": "Valor fuera de rango",
      "validation-range-formatted": "{0} fuera de rango",
      "validation-stringLength": "El tamaño del valor es incorrecto",
      "validation-stringLength-formatted": "El tamaño de {0} es incorrecto",
      "validation-custom": "Valor inválido",
      "validation-custom-formatted": "{0} inválido",
      "validation-async": "Valor inválido",
      "validation-async-formatted": "{0} inválido",
      "validation-compare": "Valores no coinciden",
      "validation-compare-formatted": "{0} no coinciden",
      "validation-pattern": "Valor no coincide con el patrón",
      "validation-pattern-formatted": "{0} no coincide con el patrón",
      "validation-email": "Email inválido",
      "validation-email-formatted": "{0} inválido",
      "validation-mask": "Valor inválido",

      "dxLookup-searchPlaceholder": "Cantidad mínima de caracteres: {0}",

      "dxList-pullingDownText": "Desliza hacia abajo para actualizar...",
      "dxList-pulledDownText": "Suelta para actualizar...",
      "dxList-refreshingText": "Actualizando...",
      "dxList-pageLoadingText": "Cargando...",
      "dxList-nextButtonText": "Más",
      "dxList-selectAll": "Seleccionar Todo",
      "dxListEditDecorator-delete": "Eliminar",
      "dxListEditDecorator-more": "Más",

      "dxScrollView-pullingDownText": "Desliza hacia abajo para actualizar...",
      "dxScrollView-pulledDownText": "Suelta para actualizar...",
      "dxScrollView-refreshingText": "Actualizando...",
      "dxScrollView-reachBottomText": "Cargando...",

      "dxDateBox-simulatedDataPickerTitleTime": "Seleccione hora",
      "dxDateBox-simulatedDataPickerTitleDate": "Seleccione fecha",
      "dxDateBox-simulatedDataPickerTitleDateTime": "Seleccione fecha y hora",
      "dxDateBox-validation-datetime": "Valor debe ser una fecha u hora",

      "dxFileUploader-selectFile": "Seleccionar archivo",
      "dxFileUploader-dropFile": "o arrastre un archivo aquí",
      "dxFileUploader-bytes": "bytes",
      "dxFileUploader-kb": "kb",
      "dxFileUploader-Mb": "Mb",
      "dxFileUploader-Gb": "Gb",
      "dxFileUploader-upload": "Subir",
      "dxFileUploader-uploaded": "Subido",
      "dxFileUploader-readyToUpload": "Listo para subir",
      "dxFileUploader-uploadAbortedMessage": "Carga cancelada",
      "dxFileUploader-uploadFailedMessage": "Falla ao subir",
      "dxFileUploader-invalidFileExtension": "Tipo de archivo no está permitido",
      "dxFileUploader-invalidMaxFileSize": "Archivo es muy grande",
      "dxFileUploader-invalidMinFileSize": "Archivo es muy pequeño",

      "dxRangeSlider-ariaFrom": "Desde",
      "dxRangeSlider-ariaTill": "Hasta",
      "dxSwitch-switchedOnText": "ENCENDIDO",
      "dxSwitch-switchedOffText": "APAGADO",

      "dxForm-optionalMark": "opcional",
      "dxForm-requiredMessage": "{0} es obligatorio",

      "dxNumberBox-invalidValueMessage": "Valor debe ser un número",
      "dxNumberBox-noDataText": "Sin datos",

      "dxDataGrid-columnChooserTitle": "Selector de Columnas",
      "dxDataGrid-columnChooserEmptyText": "Arrastra una columna aquí para ocultarla",
      "dxDataGrid-groupContinuesMessage": "Continúa en la página siguiente",
      "dxDataGrid-groupContinuedMessage": "Continuación de la página anterior",
      "dxDataGrid-groupHeaderText": "Agrupar por esta columna",
      "dxDataGrid-ungroupHeaderText": "Desagrupar",
      "dxDataGrid-ungroupAllText": "Desagrupar Todo",
      "dxDataGrid-editingEditRow": "Modificar",
      "dxDataGrid-editingSaveRowChanges": "Guardar",
      "dxDataGrid-editingCancelRowChanges": "Cancelar",
      "dxDataGrid-editingDeleteRow": "Eliminar",
      "dxDataGrid-editingUndeleteRow": "Recuperar",
      "dxDataGrid-editingConfirmDeleteMessage": "¿Está seguro que desea eliminar este registro?",
      "dxDataGrid-validationCancelChanges": "Cancelar cambios",
      "dxDataGrid-groupPanelEmptyText": "Arrastra una columna aquí para agrupar por ella",
      "dxDataGrid-noDataText": "Sin datos",
      "dxDataGrid-searchPanelPlaceholder": "Buscar...",
      "dxDataGrid-filterRowShowAllText": "(Todos)",
      "dxDataGrid-filterRowResetOperationText": "Reestablecer",
      "dxDataGrid-filterRowOperationEquals": "Igual",
      "dxDataGrid-filterRowOperationNotEquals": "No es igual",
      "dxDataGrid-filterRowOperationLess": "Menor que",
      "dxDataGrid-filterRowOperationLessOrEquals": "Menor o igual a",
      "dxDataGrid-filterRowOperationGreater": "Mayor que",
      "dxDataGrid-filterRowOperationGreaterOrEquals": "Mayor o igual a",
      "dxDataGrid-filterRowOperationStartsWith": "Empieza con",
      "dxDataGrid-filterRowOperationContains": "Contiene",
      "dxDataGrid-filterRowOperationNotContains": "No contiene",
      "dxDataGrid-filterRowOperationEndsWith": "Termina con",
      "dxDataGrid-filterRowOperationBetween": "Entre",
      "dxDataGrid-filterRowOperationBetweenStartText": "Inicio",
      "dxDataGrid-filterRowOperationBetweenEndText": "Fin",
      "dxDataGrid-applyFilterText": "Filtrar",
      "dxDataGrid-trueText": "verdadero",
      "dxDataGrid-falseText": "falso",
      "dxDataGrid-sortingAscendingText": "Orden Ascendente",
      "dxDataGrid-sortingDescendingText": "Orden Descendente",
      "dxDataGrid-sortingClearText": "Limpiar Ordenamiento",
      "dxDataGrid-editingSaveAllChanges": "Guardar cambios",
      "dxDataGrid-editingCancelAllChanges": "Descartar cambios",
      "dxDataGrid-editingAddRow": "Agregar una fila",
      "dxDataGrid-summaryMin": "Mín: {0}",
      "dxDataGrid-summaryMinOtherColumn": "Mín de {1} es {0}",
      "dxDataGrid-summaryMax": "Máx: {0}",
      "dxDataGrid-summaryMaxOtherColumn": "Máx de {1} es {0}",
      "dxDataGrid-summaryAvg": "Prom: {0}",
      "dxDataGrid-summaryAvgOtherColumn": "Prom de {1} es {0}",
      "dxDataGrid-summarySum": "Suma: {0}",
      "dxDataGrid-summarySumOtherColumn": "Suma de {1} es {0}",
      "dxDataGrid-summaryCount": "Cantidad: {0}",
      "dxDataGrid-columnFixingFix": "Anclar",
      "dxDataGrid-columnFixingUnfix": "Desanclar",
      "dxDataGrid-columnFixingLeftPosition": "A la izquierda",
      "dxDataGrid-columnFixingRightPosition": "A la derecha",
      "dxDataGrid-exportTo": "Exportar",
      "dxDataGrid-exportToExcel": "Exportar a archivo Excel",
      "dxDataGrid-exporting": "Exportar...",
      "dxDataGrid-excelFormat": "Archivo Excel",
      "dxDataGrid-exportAll": "Exportar todo a {0}",
      "dxDataGrid-exportSelectedRows": "Exportar filas seleccionadas a {0}",
      "dxDataGrid-selectedRows": "Filas seleccionadas",
      "dxDataGrid-headerFilterLabel": "Opciones de filtro",
      "dxDataGrid-headerFilterIndicatorLabel": "Mostrar opciones de filtro para la columna '{0}'",
      "dxDataGrid-headerFilterEmptyValue": "(Vacio)",
      "dxDataGrid-headerFilterOK": "Aceptar",
      "dxDataGrid-headerFilterCancel": "Cancelar",
      "dxDataGrid-ariaAdaptiveCollapse": "Ocultar datos adicionales",
      "dxDataGrid-ariaAdaptiveExpand": "Mostrar datos adicionales",
      "dxDataGrid-ariaColumn": "Columna",
      "dxDataGrid-ariaValue": "Valor",
      "dxDataGrid-ariaFilterCell": "Celda de filtro",
      "dxDataGrid-ariaCollapse": "Colapsar",
      "dxDataGrid-ariaExpand": "Expandir",
      "dxDataGrid-ariaDataGrid": "Tabla de datos",
      "dxDataGrid-ariaSearchInGrid": "Buscar en la tabla de datos",
      "dxDataGrid-ariaSelectAll": "Seleccionar todo",
      "dxDataGrid-ariaSelectRow": "Seleccionar fila",
      "dxDataGrid-ariaToolbar": "Herramientas de tabla de datos",
      "dxDataGrid-filterBuilderPopupTitle": "Constructor de filtro",
      "dxDataGrid-filterPanelCreateFilter": "Crear filtro",
      "dxDataGrid-filterPanelClearFilter": "Limpiar filtro",
      "dxDataGrid-filterPanelFilterEnabledHint": "Habilitar filtro",

      "dxTreeList-ariaTreeList": "Lista de árbol",
      "dxTreeList-ariaSearchInGrid": "Buscar en la lista de árbol",
      "dxTreeList-ariaToolbar": "Herramientas de la lista de árbol",
      "dxTreeList-editingAddRowToNode": "Añadir",

      "dxPager-infoText": "Página {0} de {1} ({2} ítems)",
      "dxPager-pagesCountText": "de",
      "dxPager-pageSize": "Elementos por página: {0}",
      "dxPager-pageSizesAllText": "Todos",
      "dxPager-page": "Página {0}",
      "dxPager-prevPage": "Página anterior",
      "dxPager-nextPage": "Página siguiente",
      "dxPager-ariaLabel": "Navegación de página",

      "dxPivotGrid-grandTotal": "Gran Total",
      "dxPivotGrid-total": "{0} Total",
      "dxPivotGrid-fieldChooserTitle": "Selector de Campos",
      "dxPivotGrid-showFieldChooser": "Mostrar Selector de Campos",
      "dxPivotGrid-expandAll": "Expandir Todo",
      "dxPivotGrid-collapseAll": "Colapsar Todo",
      "dxPivotGrid-sortColumnBySummary": "Ordenar \"{0}\" por esta columna",
      "dxPivotGrid-sortRowBySummary": "Ordenar \"{0}\" por esta fila",
      "dxPivotGrid-removeAllSorting": "Remover ordenamiento",
      "dxPivotGrid-dataNotAvailable": "N/A",
      "dxPivotGrid-rowFields": "Campos de fila",
      "dxPivotGrid-columnFields": "Campos de columna",
      "dxPivotGrid-dataFields": "Campos de dato",
      "dxPivotGrid-filterFields": "Campos de filtro",
      "dxPivotGrid-allFields": "Todos los campos",
      "dxPivotGrid-columnFieldArea": "Arrastra campos de columna aquí",
      "dxPivotGrid-dataFieldArea": "Arrastra campos de dato aquí",
      "dxPivotGrid-rowFieldArea": "Arrastra campos de fila aquí",
      "dxPivotGrid-filterFieldArea": "Arrastra campos de filtro aquí",

      "dxScheduler-editorLabelTitle": "Asunto",
      "dxScheduler-editorLabelStartDate": "Fecha inicial",
      "dxScheduler-editorLabelEndDate": "Fecha final",
      "dxScheduler-editorLabelDescription": "Descripción",
      "dxScheduler-editorLabelRecurrence": "Repetir",

      "dxScheduler-openAppointment": "Abrir cita",

      "dxScheduler-recurrenceNever": "Nunca",
      "dxScheduler-recurrenceMinutely": "Cada minuto",
      "dxScheduler-recurrenceHourly": "Cada hora",
      "dxScheduler-recurrenceDaily": "Diario",
      "dxScheduler-recurrenceWeekly": "Semanal",
      "dxScheduler-recurrenceMonthly": "Mensual",
      "dxScheduler-recurrenceYearly": "Anual",

      "dxScheduler-recurrenceRepeatEvery": "Cada",
      "dxScheduler-recurrenceRepeatOn": "Repeat On",
      "dxScheduler-recurrenceEnd": "Terminar repetición",
      "dxScheduler-recurrenceAfter": "Después",
      "dxScheduler-recurrenceOn": "En",

      "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
      "dxScheduler-recurrenceRepeatHourly": "hour(s)",
      "dxScheduler-recurrenceRepeatDaily": "día(s)",
      "dxScheduler-recurrenceRepeatWeekly": "semana(s)",
      "dxScheduler-recurrenceRepeatMonthly": "mes(es)",
      "dxScheduler-recurrenceRepeatYearly": "año(s)",

      "dxScheduler-switcherDay": "Día",
      "dxScheduler-switcherWeek": "Semana",
      "dxScheduler-switcherWorkWeek": "Semana Laboral",
      "dxScheduler-switcherMonth": "Mes",

      "dxScheduler-switcherAgenda": "Agenda",

      "dxScheduler-switcherTimelineDay": "Línea de tiempo Día",
      "dxScheduler-switcherTimelineWeek": "Línea de tiempo Semana",
      "dxScheduler-switcherTimelineWorkWeek": "Línea de tiempo Semana Laboral",
      "dxScheduler-switcherTimelineMonth": "Línea de tiempo Mes",

      "dxScheduler-recurrenceRepeatOnDate": "en la fecha",
      "dxScheduler-recurrenceRepeatCount": "ocurrencia(s)",
      "dxScheduler-allDay": "Todo el día",

      "dxScheduler-confirmRecurrenceEditMessage": "¿Quiere modificar solo esta cita o toda la serie?",
      "dxScheduler-confirmRecurrenceDeleteMessage": "¿Quiere eliminar solo esta cita o toda la serie?",

      "dxScheduler-confirmRecurrenceEditSeries": "Modificar serie",
      "dxScheduler-confirmRecurrenceDeleteSeries": "Eliminar serie",
      "dxScheduler-confirmRecurrenceEditOccurrence": "Modificar cita",
      "dxScheduler-confirmRecurrenceDeleteOccurrence": "Eliminar cita",

      "dxScheduler-noTimezoneTitle": "Sin zona horaria",
      "dxScheduler-moreAppointments": "{0} más",

      "dxCalendar-todayButtonText": "Hoy",
      "dxCalendar-ariaWidgetName": "Calendario",

      "dxColorView-ariaRed": "Rojo",
      "dxColorView-ariaGreen": "Verde",
      "dxColorView-ariaBlue": "Azul",
      "dxColorView-ariaAlpha": "Transparencia",
      "dxColorView-ariaHex": "Código del color",

      "dxTagBox-selected": "{0} seleccionado",
      "dxTagBox-allSelected": "Todos seleccionados ({0})",
      "dxTagBox-moreSelected": "{0} más",

      "vizExport-printingButtonText": "Imprimir",
      "vizExport-titleMenuText": "Exportar/Imprimir",
      "vizExport-exportButtonText": "Archivo {0}",

      "dxFilterBuilder-and": "Y",
      "dxFilterBuilder-or": "O",
      "dxFilterBuilder-notAnd": "NO Y",
      "dxFilterBuilder-notOr": "NO O",
      "dxFilterBuilder-addCondition": "Añadir condición",
      "dxFilterBuilder-addGroup": "Añadir Grupo",
      "dxFilterBuilder-enterValueText": "<rellene con un valor>",
      "dxFilterBuilder-filterOperationEquals": "Igual",
      "dxFilterBuilder-filterOperationNotEquals": "Diferente",
      "dxFilterBuilder-filterOperationLess": "Menos que",
      "dxFilterBuilder-filterOperationLessOrEquals": "Menor o igual que",
      "dxFilterBuilder-filterOperationGreater": "Más grande que",
      "dxFilterBuilder-filterOperationGreaterOrEquals": "Mayor o igual que",
      "dxFilterBuilder-filterOperationStartsWith": "Comienza con",
      "dxFilterBuilder-filterOperationContains": "Contiene",
      "dxFilterBuilder-filterOperationNotContains": "No contiene",
      "dxFilterBuilder-filterOperationEndsWith": "Termina con",
      "dxFilterBuilder-filterOperationIsBlank": "Vacío",
      "dxFilterBuilder-filterOperationIsNotBlank": "No vacío",
      "dxFilterBuilder-filterOperationBetween": "Entre",
      "dxFilterBuilder-filterOperationAnyOf": "Alguno de",
      "dxFilterBuilder-filterOperationNoneOf": "Ningún de",

      "dxHtmlEditor-dialogColorCaption": "Cambiar el color de la fuente",
      "dxHtmlEditor-dialogBackgroundCaption": "Cambiar el color de fondo",
      "dxHtmlEditor-dialogLinkCaption": "Añadir enlace",
      "dxHtmlEditor-dialogLinkUrlField": "URL",
      "dxHtmlEditor-dialogLinkTextField": "Texto",
      "dxHtmlEditor-dialogLinkTargetField": "Abrir enlace en nueva ventana",
      "dxHtmlEditor-dialogImageCaption": "Añadir imagen",
      "dxHtmlEditor-dialogImageUrlField": "URL",
      "dxHtmlEditor-dialogImageAltField": "Texto alternativo",
      "dxHtmlEditor-dialogImageWidthField": "Anchura (px)",
      "dxHtmlEditor-dialogImageHeightField": "Altura (px)",
      "dxHtmlEditor-dialogInsertTableRowsField": "Filas",
      "dxHtmlEditor-dialogInsertTableColumnsField": "Columnas",
      "dxHtmlEditor-dialogInsertTableCaption": "Insertar tabla",
      "dxHtmlEditor-dialogUpdateImageCaption": "Actualizar imagen",
      "dxHtmlEditor-dialogImageUpdateButton": "Actualizar",
      "dxHtmlEditor-dialogImageAddButton": "Añadir",
      "dxHtmlEditor-dialogImageSpecifyUrl": "Desde la Web",
      "dxHtmlEditor-dialogImageSelectFile": "Desde este dispositivo",
      "dxHtmlEditor-dialogImageKeepAspectRatio": "Mantener relación de aspecto",
      "dxHtmlEditor-dialogImageEncodeToBase64": "Codificar a Base64",
      "dxHtmlEditor-heading": "Encabezamiento",
      "dxHtmlEditor-normalText": "Texto normal",
      "dxHtmlEditor-background": "Color de fondo",
      "dxHtmlEditor-bold": "Negrito",
      "dxHtmlEditor-color": "Color de fuente",
      "dxHtmlEditor-font": "Fuente",
      "dxHtmlEditor-italic": "Itálico",
      "dxHtmlEditor-link": "Añadir enlace",
      "dxHtmlEditor-image": "Añadir imagen",
      "dxHtmlEditor-size": "Tamaño",
      "dxHtmlEditor-strike": "Tachado",
      "dxHtmlEditor-subscript": "Subíndice",
      "dxHtmlEditor-superscript": "Sobrescrito",
      "dxHtmlEditor-underline": "Subrayar",
      "dxHtmlEditor-blockquote": "Cita en bloque",
      "dxHtmlEditor-header": "Encabezamiento",
      "dxHtmlEditor-increaseIndent": "Aumentar sangría",
      "dxHtmlEditor-decreaseIndent": "Disminuir sangría",
      "dxHtmlEditor-orderedList": "Lista ordenada",
      "dxHtmlEditor-bulletList": "Lista de viñetas",
      "dxHtmlEditor-alignLeft": "Alinear a la izquierda",
      "dxHtmlEditor-alignCenter": "Alinear al centro",
      "dxHtmlEditor-alignRight": "Alinear a la derecha",
      "dxHtmlEditor-alignJustify": "Alinear Justificar",
      "dxHtmlEditor-codeBlock": "Bloque de código",
      "dxHtmlEditor-variable": "Añadir variable",
      "dxHtmlEditor-undo": "Deshacer",
      "dxHtmlEditor-redo": "Rehacer",
      "dxHtmlEditor-clear": "Limpiar formato",
      "dxHtmlEditor-insertTable": "Insertar tabla",
      "dxHtmlEditor-insertHeaderRow": "Insertar fila de encabezado",
      "dxHtmlEditor-insertRowAbove": "Insertar fila arriba",
      "dxHtmlEditor-insertRowBelow": "Insertar fila debajo",
      "dxHtmlEditor-insertColumnLeft": "Insertar columna a la izquierda",
      "dxHtmlEditor-insertColumnRight": "Insertar columna a la derecha",
      "dxHtmlEditor-deleteColumn": "Borrar Columna",
      "dxHtmlEditor-deleteRow": "Borrar fila",
      "dxHtmlEditor-deleteTable": "Borrar tabla",
      "dxHtmlEditor-cellProperties": "Propiedades de celda",
      "dxHtmlEditor-tableProperties": "Propiedades de la tabla",
      "dxHtmlEditor-insert": "Insertar",
      "dxHtmlEditor-delete": "Borrar",
      "dxHtmlEditor-border": "Borde",
      "dxHtmlEditor-style": "Estilo",
      "dxHtmlEditor-width": "Ancho",
      "dxHtmlEditor-height": "Altura",
      "dxHtmlEditor-borderColor": "Color",
      "dxHtmlEditor-tableBackground": "Fondo",
      "dxHtmlEditor-dimensions": "Dimensiones",
      "dxHtmlEditor-alignment": "Alineamiento",
      "dxHtmlEditor-horizontal": "Horizontal",
      "dxHtmlEditor-vertical": "Vertical",
      "dxHtmlEditor-paddingVertical": "Relleno vertical",
      "dxHtmlEditor-paddingHorizontal": "Relleno horizontal",
      "dxHtmlEditor-pixels": "Píxeles",
      "dxHtmlEditor-list": "Listado",
      "dxHtmlEditor-ordered": "Ordenado",
      "dxHtmlEditor-bullet": "Viñeta",
      "dxHtmlEditor-align": "Alinear",
      "dxHtmlEditor-center": "Centro",
      "dxHtmlEditor-left": "Izquierda",
      "dxHtmlEditor-right": "Derecha",
      "dxHtmlEditor-indent": "Endentar",
      "dxHtmlEditor-justify": "Justificar",

      "dxFileManager-newDirectoryName": "Sin título",
      "dxFileManager-rootDirectoryName": "Archivos",
      "dxFileManager-errorNoAccess": "Acceso denegado. La operación no se puede completar.",
      "dxFileManager-errorDirectoryExistsFormat": "Carpeta {0} ya existe.",
      "dxFileManager-errorFileExistsFormat": "Archivo {0} ya existe.",
      "dxFileManager-errorFileNotFoundFormat": "Archivo {0} no encontrado.",
      "dxFileManager-errorDirectoryNotFoundFormat": "Directorio '{0}' no encontrado.",
      "dxFileManager-errorWrongFileExtension": "La extensión de archivo no está permitida.",
      "dxFileManager-errorMaxFileSizeExceeded": "El tamaño del archivo supera el tamaño máximo permitido.",
      "dxFileManager-errorInvalidSymbols": "Este nombre contiene caracteres no válidos.",
      "dxFileManager-errorDefault": "Error no especificado.",
      "dxFileManager-errorDirectoryOpenFailed": "No se puede abrir el directorio.",

      "dxFileManager-commandCreate": "Nuevo directorio",
      "dxFileManager-commandRename": "Renombrar",
      "dxFileManager-commandMove": "Mover a",
      "dxFileManager-commandCopy": "Copiar a",
      "dxFileManager-commandDelete": "Borrar",
      "dxFileManager-commandDownload": "Descargar",
      "dxFileManager-commandUpload": "Subir archivos",
      "dxFileManager-commandRefresh": "Actualizar",
      "dxFileManager-commandThumbnails": "Vista de miniaturas",
      "dxFileManager-commandDetails": "Vista de detalles",
      "dxFileManager-commandClearSelection": "Limpiar selección",
      "dxFileManager-commandShowNavPane": "Alternar panel de navegación",

      "dxFileManager-dialogDirectoryChooserMoveTitle": "Mover a",
      "dxFileManager-dialogDirectoryChooserMoveButtonText": "Mover",
      "dxFileManager-dialogDirectoryChooserCopyTitle": "Copiar a",
      "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copiar",
      "dxFileManager-dialogRenameItemTitle": "Renombrar",
      "dxFileManager-dialogRenameItemButtonText": "Guardar",
      "dxFileManager-dialogCreateDirectoryTitle": "Nuevo directorio",
      "dxFileManager-dialogCreateDirectoryButtonText": "Crear",
      "dxFileManager-dialogDeleteItemTitle": "Borrar",
      "dxFileManager-dialogDeleteItemButtonText": "Borrar",
      "dxFileManager-dialogDeleteItemSingleItemConfirmation": "¿Estás seguro de que quieres eliminar {0}?",
      "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "¿Estás seguro de que quieres eliminar {0} artículos?",
      "dxFileManager-dialogButtonCancel": "Cancelar",

      "dxFileManager-editingCreateSingleItemProcessingMessage": "Creando un directorio dentro de {0}",
      "dxFileManager-editingCreateSingleItemSuccessMessage": "Creó un directorio dentro de {0}",
      "dxFileManager-editingCreateSingleItemErrorMessage": "No se creó el directorio",
      "dxFileManager-editingCreateCommonErrorMessage": "No se creó el directorio",

      "dxFileManager-editingRenameSingleItemProcessingMessage": "Cambiar el nombre de un elemento dentro de {0}",
      "dxFileManager-editingRenameSingleItemSuccessMessage": "Cambió el nombre de un elemento dentro de {0}",
      "dxFileManager-editingRenameSingleItemErrorMessage": "No se cambió el nombre del elemento",
      "dxFileManager-editingRenameCommonErrorMessage": "No se cambió el nombre del elemento",

      "dxFileManager-editingDeleteSingleItemProcessingMessage": "Eliminar un elemento de {0}",
      "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Eliminando {0} elementos de {1}",
      "dxFileManager-editingDeleteSingleItemSuccessMessage": "Eliminó un elemento de {0}",
      "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "{0} elementos eliminados de {1}",
      "dxFileManager-editingDeleteSingleItemErrorMessage": "El elemento no fue eliminado",
      "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} elementos no se eliminaron",
      "dxFileManager-editingDeleteCommonErrorMessage": "Algunos elementos no se eliminaron",

      "dxFileManager-editingMoveSingleItemProcessingMessage": "Moviendo un elemento a {0}",
      "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moviendo {0} elementos a {1}",
      "dxFileManager-editingMoveSingleItemSuccessMessage": "Movió un elemento a {0}",
      "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Se movieron {0} elementos a {1}",
      "dxFileManager-editingMoveSingleItemErrorMessage": "El elemento no se movió",
      "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} elementos no se movieron",
      "dxFileManager-editingMoveCommonErrorMessage": "Algunos elementos no se movieron",

      "dxFileManager-editingCopySingleItemProcessingMessage": "Copiando un elemento a {0}",
      "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copiando {0} elementos a {1}",
      "dxFileManager-editingCopySingleItemSuccessMessage": "Copiado un elemento a {0}",
      "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copiado {0} elementos a {1}",
      "dxFileManager-editingCopySingleItemErrorMessage": "El elemento no fue copiado",
      "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} elementos no se copiaron",
      "dxFileManager-editingCopyCommonErrorMessage": "Algunos artículos no fueron copiados",

      "dxFileManager-editingUploadSingleItemProcessingMessage": "Subiendo un elemento a {0}",
      "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Subiendo {0} elementos a {1}",
      "dxFileManager-editingUploadSingleItemSuccessMessage": "Subió un elemento a {0}",
      "dxFileManager-editingUploadMultipleItemsSuccessMessage": "{0} elementos subidos a {1}",
      "dxFileManager-editingUploadSingleItemErrorMessage": "El artículo no fue subido",
      "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} elementos no se cargaron",
      "dxFileManager-editingUploadCanceledMessage": "Cancelado",

      "dxFileManager-editingDownloadSingleItemErrorMessage": "El elemento no se descargó",
      "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} elementos no se descargaron",

      "dxFileManager-listDetailsColumnCaptionName": "Nombre",
      "dxFileManager-listDetailsColumnCaptionDateModified": "Fecha modificada",
      "dxFileManager-listDetailsColumnCaptionFileSize": "Tamaño del archivo",

      "dxFileManager-listThumbnailsTooltipTextSize": "Tamaño",
      "dxFileManager-listThumbnailsTooltipTextDateModified": "Fecha modificada",

      "dxFileManager-notificationProgressPanelTitle": "Progreso",
      "dxFileManager-notificationProgressPanelEmptyListText": "Sin operaciones",
      "dxFileManager-notificationProgressPanelOperationCanceled": "Cancelado",

      "dxDiagram-categoryGeneral": "General",
      "dxDiagram-categoryFlowchart": "Diagrama de flujo",
      "dxDiagram-categoryOrgChart": "Organigrama",
      "dxDiagram-categoryContainers": "Contenedores",
      "dxDiagram-categoryCustom": "Personalizado",

      "dxDiagram-commandExportToSvg": "Exportar a SVG",
      "dxDiagram-commandExportToPng": "Exportar a PNG",
      "dxDiagram-commandExportToJpg": "Exportar a JPG",
      "dxDiagram-commandUndo": "Deshacer",
      "dxDiagram-commandRedo": "Rehacer",
      "dxDiagram-commandFontName": "Nombre de fuente",
      "dxDiagram-commandFontSize": "Tamaño de fuente",
      "dxDiagram-commandBold": "Negrita",
      "dxDiagram-commandItalic": "Cursiva",
      "dxDiagram-commandUnderline": "Subrayado",
      "dxDiagram-commandTextColor": "Color de fuente",
      "dxDiagram-commandLineColor": "Color de línea",
      "dxDiagram-commandLineWidth": "Ancho de línea",
      "dxDiagram-commandLineStyle": "Estilo de línea",
      "dxDiagram-commandLineStyleSolid": "Sólido",
      "dxDiagram-commandLineStyleDotted": "De puntos",
      "dxDiagram-commandLineStyleDashed": "De guiones",
      "dxDiagram-commandFillColor": "Color de relleno",
      "dxDiagram-commandAlignLeft": "Alinear a la izquierda",
      "dxDiagram-commandAlignCenter": "Alinear al centro",
      "dxDiagram-commandAlignRight": "Alinear a la derecha",
      "dxDiagram-commandConnectorLineType": "Tipo de línea de conector",
      "dxDiagram-commandConnectorLineStraight": "Recto",
      "dxDiagram-commandConnectorLineOrthogonal": "Ortogonal",
      "dxDiagram-commandConnectorLineStart": "Conector de inicio de línea",
      "dxDiagram-commandConnectorLineEnd": "Conector de final de línea",
      "dxDiagram-commandConnectorLineNone": "Ninguno",
      "dxDiagram-commandConnectorLineArrow": "Flecha",
      "dxDiagram-commandFullscreen": "Pantalla completa",
      "dxDiagram-commandUnits": "Unidades",
      "dxDiagram-commandPageSize": "Tamaño de página",
      "dxDiagram-commandPageOrientation": "Orientación de página",
      "dxDiagram-commandPageOrientationLandscape": "Horizontal",
      "dxDiagram-commandPageOrientationPortrait": "Vertical",
      "dxDiagram-commandPageColor": "Color de página",
      "dxDiagram-commandShowGrid": "Mostrar cuadrícula",
      "dxDiagram-commandSnapToGrid": "Ajustar a la cuadrícula",
      "dxDiagram-commandGridSize": "Tamaño de cuadrícula",
      "dxDiagram-commandZoomLevel": "Nivel de zoom",
      "dxDiagram-commandAutoZoom": "Zoom automático",
      "dxDiagram-commandFitToContent": "Ajustar al contenido",
      "dxDiagram-commandFitToWidth": "Ajustar al ancho",
      "dxDiagram-commandAutoZoomByContent": "Zoom automático por contenido",
      "dxDiagram-commandAutoZoomByWidth": "Zoom automático por ancho",
      "dxDiagram-commandSimpleView": "Vista Simple",
      "dxDiagram-commandCut": "Cortar",
      "dxDiagram-commandCopy": "Copiar",
      "dxDiagram-commandPaste": "Pegar",
      "dxDiagram-commandSelectAll": "Seleccionar todo",
      "dxDiagram-commandDelete": "Eliminar",
      "dxDiagram-commandBringToFront": "Traer al frente",
      "dxDiagram-commandSendToBack": "Enviar al fondo",
      "dxDiagram-commandLock": "Bloquear",
      "dxDiagram-commandUnlock": "Desbloquear",
      "dxDiagram-commandInsertShapeImage": "Insertar imagen...",
      "dxDiagram-commandEditShapeImage": "Cambiar imagen...",
      "dxDiagram-commandDeleteShapeImage": "Eliminar imagen",
      "dxDiagram-commandLayoutLeftToRight": "De izquierda a derecha",
      "dxDiagram-commandLayoutRightToLeft": "De derecha a izquierda",
      "dxDiagram-commandLayoutTopToBottom": "De arriba a abajo",
      "dxDiagram-commandLayoutBottomToTop": "De abajo a arriba",

      "dxDiagram-unitIn": "pulg.",
      "dxDiagram-unitCm": "cm",
      "dxDiagram-unitPx": "px",

      "dxDiagram-dialogButtonOK": "Aceptar",
      "dxDiagram-dialogButtonCancel": "Cancelar",
      "dxDiagram-dialogInsertShapeImageTitle": "Insertar Imagen",
      "dxDiagram-dialogEditShapeImageTitle": "Cambiar Imagen",
      "dxDiagram-dialogEditShapeImageSelectButton": "Seleccionar imagen",
      "dxDiagram-dialogEditShapeImageLabelText": "o colocar el archivo aquí",

      "dxDiagram-uiExport": "Exportar",
      "dxDiagram-uiProperties": "Propiedades",
      "dxDiagram-uiSettings": "Configuración",
      "dxDiagram-uiShowToolbox": "Cuadro de herramientas",
      "dxDiagram-uiSearch": "Buscar",
      "dxDiagram-uiStyle": "Estilo",
      "dxDiagram-uiLayout": "Diseño",
      "dxDiagram-uiLayoutTree": "Árbol",
      "dxDiagram-uiLayoutLayered": "Capas",
      "dxDiagram-uiDiagram": "Diagrama",
      "dxDiagram-uiText": "Texto",
      "dxDiagram-uiObject": "Objeto",
      "dxDiagram-uiConnector": "Conector",
      "dxDiagram-uiPage": "Página",

      "dxDiagram-shapeText": "Texto",
      "dxDiagram-shapeRectangle": "Rectángulo",
      "dxDiagram-shapeEllipse": "Elipse",
      "dxDiagram-shapeCross": "Cruz",
      "dxDiagram-shapeTriangle": "Triángulo",
      "dxDiagram-shapeDiamond": "Rombo",
      "dxDiagram-shapeHeart": "Corazón",
      "dxDiagram-shapePentagon": "Pentágono",
      "dxDiagram-shapeHexagon": "Hexágono",
      "dxDiagram-shapeOctagon": "Octágono",
      "dxDiagram-shapeStar": "Estrella",
      "dxDiagram-shapeArrowLeft": "Flecha izquierda",
      "dxDiagram-shapeArrowUp": "Flecha arriba",
      "dxDiagram-shapeArrowRight": "Flecha derecha",
      "dxDiagram-shapeArrowDown": "Flecha abajo",
      "dxDiagram-shapeArrowUpDown": "Flecha arriba/abajo",
      "dxDiagram-shapeArrowLeftRight": "Flecha izquierda/derecha",
      "dxDiagram-shapeProcess": "Proceso",
      "dxDiagram-shapeDecision": "Decisión",
      "dxDiagram-shapeTerminator": "Terminador",
      "dxDiagram-shapePredefinedProcess": "Proceso predefinido",
      "dxDiagram-shapeDocument": "Documento",
      "dxDiagram-shapeMultipleDocuments": "Varios documentos",
      "dxDiagram-shapeManualInput": "Entrada manual",
      "dxDiagram-shapePreparation": "Preparación",
      "dxDiagram-shapeData": "Datos",
      "dxDiagram-shapeDatabase": "Base de datos",
      "dxDiagram-shapeHardDisk": "Disco duro",
      "dxDiagram-shapeInternalStorage": "Almacenamiento interno",
      "dxDiagram-shapePaperTape": "Cinta de papel",
      "dxDiagram-shapeManualOperation": "Operación manual",
      "dxDiagram-shapeDelay": "Retraso",
      "dxDiagram-shapeStoredData": "Datos almacenados",
      "dxDiagram-shapeDisplay": "Pantalla",
      "dxDiagram-shapeMerge": "Combinar",
      "dxDiagram-shapeConnector": "Conector",
      "dxDiagram-shapeOr": "O",
      "dxDiagram-shapeSummingJunction": "Unión en Y",
      "dxDiagram-shapeContainerDefaultText": "Contenedor",
      "dxDiagram-shapeVerticalContainer": "Contenedor vertical",
      "dxDiagram-shapeHorizontalContainer": "Contenedor horizontal",
      "dxDiagram-shapeCardDefaultText": "Nombre de persona",
      "dxDiagram-shapeCardWithImageOnLeft": "Tarjeta con imagen a la izquierda",
      "dxDiagram-shapeCardWithImageOnTop": "Tarjeta con imagen en la parte superior",
      "dxDiagram-shapeCardWithImageOnRight": "Tarjeta con imagen a la derecha",

      "dxGantt-dialogTitle": "Título",
      "dxGantt-dialogStartTitle": "Inicio",
      "dxGantt-dialogEndTitle": "Final",
      "dxGantt-dialogProgressTitle": "Progreso",
      "dxGantt-dialogResourcesTitle": "Recursos",
      "dxGantt-dialogResourceManagerTitle": "Administrador de recursos",
      "dxGantt-dialogTaskDetailsTitle": "Detalles de la tarea",
      "dxGantt-dialogEditResourceListHint": "Editar lista de recursos",
      "dxGantt-dialogEditNoResources": "Sin recursos",
      "dxGantt-dialogButtonAdd": "Añadir",
      "dxGantt-contextMenuNewTask": "Nueva tarea",
      "dxGantt-contextMenuNewSubtask": "Nueva subtarea",
      "dxGantt-contextMenuDeleteTask": "Borrar tarea",
      "dxGantt-contextMenuDeleteDependency": "Borrar dependencia",
      "dxGantt-dialogTaskDeleteConfirmation": "Borrar una tarea también elimina todas sus dependencias y subtareas. ¿Está seguro de que desea borrar esta tarea?",
      "dxGantt-dialogDependencyDeleteConfirmation": "¿Está seguro de que desea borrar la dependencia de la tarea?",
      "dxGantt-dialogResourcesDeleteConfirmation": "Borrar un recurso también lo elimina de las tareas a las que está asignado este recurso. ¿Está seguro de que desea borrar estos recursos? Recursos: {0}",
      "dxGantt-dialogConstraintCriticalViolationMessage": "La tarea que intenta mover está vinculada a una segunda tarea por una relación de dependencia. Este cambio entraría en conflicto con las reglas de dependencia. ¿Cómo te gustaría proceder?",
      "dxGantt-dialogConstraintViolationMessage": "La tarea que intenta mover está vinculada a una segunda tarea por una relación de dependencia. ¿Cómo te gustaría proceder?",
      "dxGantt-dialogCancelOperationMessage": "Cancelar la operación",
      "dxGantt-dialogDeleteDependencyMessage": "Borrar la dependencia",
      "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Mover la tarea y mantener la dependencia",
      "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "La tarea que intenta mover está vinculada a otras tareas por relaciones de dependencia. Este cambio entraría en conflicto con las reglas de dependencia. ¿Cómo te gustaría proceder?",
      "dxGantt-dialogConstraintViolationSeveralTasksMessage": "La tarea que intenta mover está vinculada a otras tareas por relaciones de dependencia. ¿Cómo te gustaría proceder?",
      "dxGantt-dialogDeleteDependenciesMessage": "Borrar las relaciones de dependencia",
      "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Mover la tarea y mantener las dependencias",
      "dxGantt-undo": "Deshacer",
      "dxGantt-redo": "Rehacer",
      "dxGantt-expandAll": "Expandir todo",
      "dxGantt-collapseAll": "Contraer todo",
      "dxGantt-addNewTask": "Añadir nueva tarea",
      "dxGantt-deleteSelectedTask": "Borrar tarea seleccionada",
      "dxGantt-zoomIn": "Acercar el zoom",
      "dxGantt-zoomOut": "Disminuir el zoom",
      "dxGantt-fullScreen": "pantalla completa",
      "dxGantt-quarter": "{0}.º trim.",
      "dxGantt-sortingAscendingText": "Orden Ascendente",
      "dxGantt-sortingDescendingText": "Orden Descendente",
      "dxGantt-sortingClearText": "Limpiar Ordenamiento",
      "dxGantt-showResources": "Mostrar Recursos",
      "dxGantt-showDependencies": "Mostrar Dependencias",
      "dxGantt-dialogStartDateValidation": "La fecha de inicio debe ser anterior {0}",
      "dxGantt-dialogEndDateValidation": "La fecha de finalización debe ser posterior {0}"
  }
}
